export default __webpack_public_path__ + "static/media/Licenses_IMG-License-04.e0674bae.png";